module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page5...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4575d98b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav2/Page5.vue
// module id = 1043
// module chunks = 1